export const INTERNATIONAL_CHARACTERS = 'ñÑáéíóúÁÉÍÓÚüÜàèùâêîôûäëïöüÿçßæøåÀÈÙÂÊÎÔÛÄËÏÖÜŸÇßÆØÅ'

export const getEmailRegex = (): string => {
  return `^$|[A-Za-z0-9._%+-${INTERNATIONAL_CHARACTERS}]+@[A-Za-z0-9.${INTERNATIONAL_CHARACTERS}-]+\\.[A-Za-z]{2,}$`
}
